import React from 'react';


export default class RelatedProducts extends React.Component {
	constructor(props) {
		super(props);
	}
	
	createRelatedProducts(product, i) {
		return (
			<li key={product.code} className="similar-product" role="listitem">
				<a href={window.jenkon.consultantRoot + 'ProductDetails?ID=' + product.code}>
					<img src={window.jenkon.imageEndpoint + product.imageResourceKey} alt={product.productName} />
					<span className="visuallyhidden">
						{product.productName}
					</span>
				</a>
			</li>
		)
	}
	
	render() {
		return(
			<ul className="similar-products-wrapper clearfix" role="list">
				{this.props.RelatedProducts.map(this.createRelatedProducts.bind(this))}
			</ul>
		)
	}
}

RelatedProducts.defaultProps = {
	RelatedProducts: []
}


// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/ProductDetail/RelatedProducts.js